import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-690f7ce8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["for"]
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["id", "checked", "onChange"]
const _hoisted_8 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_error_message = _resolveComponent("control-error-message")!

  return (_openBlock(), _createElementBlock("fieldset", {
    class: "fieldset p-4 bg-lightblue",
    id: _ctx.compId
  }, [
    _createElementVNode("legend", { for: _ctx.compId }, [
      _createTextVNode(_toDisplayString(_ctx.$t(_ctx.i18nLabel)) + " ", 1),
      (_ctx.isRequired())
        ? (_openBlock(), _createElementBlock("abbr", {
            key: 0,
            title: _ctx.$t('common.form.required')
          }, _hoisted_5, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableWeekdays(), (weekday, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: weekday,
          class: "col"
        }, [
          _createElementVNode("input", {
            id: _ctx.compId + index,
            type: "checkbox",
            class: _normalizeClass([{ 'form-error-focusable': _ctx.validation.$error }, "form-check-input"]),
            checked: _ctx.isChecked(weekday),
            onChange: ($event: any) => (_ctx.onChange(weekday, $event.target.checked))
          }, null, 42, _hoisted_7),
          _createElementVNode("label", {
            for: _ctx.compId + index
          }, _toDisplayString(_ctx.$t('common.days.' + weekday)), 9, _hoisted_8)
        ]))
      }), 128))
    ]),
    _createVNode(_component_control_error_message, {
      validation: _ctx.validation,
      i18nLabel: _ctx.i18nLabel
    }, null, 8, ["validation", "i18nLabel"]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 8, _hoisted_1))
}